import React from "react"
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Link as ScrollTo } from "react-scroll/modules";
import { List, ListItem, ListItemButton, ListItemText, ListItemIcon } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import mobileMenuStyles from "./MobileMenuDrawer.module.css"
import MobileUploadPrescription from "../MobileUploadPrescription/MobileUploadPrescription";
import MobilePathology from "../MobilePathology/MobilePathology";

const MobileMenuDrawer = ({ setOpenMobileMenuDrawer }) => {
  const history = useHistory();
  const citySelect = useSelector((state) => state.cityOnTopNav.citySelect);
  
  const menuItems = [
    // {
    //   name: "About",
    //   href: "/about-us",
    //   ext: true,
    // },
    {
      name: "Imaging Tests",
      href: `/imaging/health-checkup-packages${citySelect ? "-" + citySelect.toLowerCase() : ""}`,
      ext: false,
    },
    {
      name: "Pathology",
      href: "/",
      ext: true,
    },
    // {
    //   name: "redO",
    //   href: "/hh",
    //   ext: false,
    // },
    // {
    //   name: "Our Labs & Network",
    //   href: "/lab-centre-network",
    //   ext: true,
    // },
    // {
    //   name: "Blogs",
    //   href: "/blog",
    //   ext: true,
    // },
    // {
    //   name: "Gift Card",
    //   href: "/gift-card",
    //   ext: true,
    // },
    {
      name: "Contact Us",
      href: "/imaging/contact",
      ext: false,
    },
    // {
    //   name: "Offers",
    //   href: "/offers",
    //   ext: false,
    // },
  ]

  const handleMenuClose = () => {
    document.getElementById("mobile-menu").classList.add(mobileMenuStyles.slideOutLeft);
    setTimeout(() => {
      setOpenMobileMenuDrawer(false);
    }, 250);
  }

  const handleItemClick = (href, ext) => {
    if (ext === false) {
      history.push(href);
    }
    else {
      window.location.href = `${process.env.RAZZLE_APP_BASE_URL}${href}`
    }
    setOpenMobileMenuDrawer(false)
  }

  return (
    <div
      className={`${mobileMenuStyles.slideInLeft} ${mobileMenuStyles.mobileMenu}`}
      id="mobile-menu"
    >
      <div className={mobileMenuStyles.topHeaderToggle}>
        <div className={mobileMenuStyles.iconContainer} onClick={handleMenuClose}>
          <MenuIcon className={mobileMenuStyles.menuIcon} />
        </div>
        <span className={mobileMenuStyles.toggleHeadingMoble}>My Menu</span>
      </div>
      <div className={mobileMenuStyles.bottomHeaderToggle}>
        {/* <MobileUploadPrescription setOpenMobileMenuDrawer={setOpenMobileMenuDrawer} /> */}

        <div>
          <List>
            {menuItems.map(({ name, href, ext }, index) => {
              if (index === 1) {
                return (
                  <div key={index}>
                    <MobilePathology setOpenMobileMenuDrawer={setOpenMobileMenuDrawer} />
                  </div>
                )
              }
              return (
                <ListItem key={index} onClick={() => handleItemClick(href, ext)} className={mobileMenuStyles.listItem}>
                  <ListItemButton className={mobileMenuStyles.listButton}>
                    <ListItemText
                      sx={{
                        '& .MuiTypography-root': {
                          fontSize: "2.2rem",
                          fontFamily: "Jost",
                          color: "#707070"
                        }
                      }}
                    >
                      {name}
                    </ListItemText>
                    <ListItemIcon sx={{ alignSelf: "center", display: "flex", justifyContent: "flex-end" }}>
                      <ArrowForwardIosIcon className={mobileMenuStyles.forwardIcon} />
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
              )
            })}

            {/* FAQs */}
            {history.location.pathname === "/imaging" &&
              <ListItem style={{ paddingLeft: "17px" }} className={mobileMenuStyles.listItem}>
                <ListItemButton className={mobileMenuStyles.listButton}>
                  <ScrollTo
                    to="faq"
                    // offset={-650}
                    smooth={true}
                    duration={500}
                    style={{
                      color: "#707070",
                      fontSize: "2.2rem",
                      display: "block",
                      width: "100%",
                    }}
                    onClick={handleMenuClose}
                  >
                    FAQs
                  </ScrollTo>
                  <ListItemIcon
                    style={{ width: "auto" }}
                    sx={{ alignSelf: "center", display: "flex", justifyContent: "flex-end" }}
                  >
                    <ArrowForwardIosIcon className={mobileMenuStyles.forwardIcon} />
                  </ListItemIcon>
                </ListItemButton>
              </ListItem>
            }
          </List>
        </div>
      </div>
    </div >
  )
}

export default MobileMenuDrawer;